<template>
	<div class="container bg_f9">
		<div class="head_part flex-box w1440">
			<router-link to="/"><img class="login_logo point mr30" src="../../assets/static/icon/jxr_login_logo.png"
					alt="" /></router-link>
			<div class="line mr30"></div>
			<div class="fs30 col-36 fw-600 flex-grow-1">欢迎注册</div>
			<router-link class="col04 fs16 blue fwb lh28 point" to="/Login"><span
					class="col36">已有账号？</span>请登录</router-link>
		</div>
		<div class="main w1440">
			<div class="progess_part flex-box flex-center">
				<div class="num_on">1</div>
				<div class="ml5 fs20 blue lh34">资料填写</div>
				<div class="line_on mlr25"></div>
				<div :class="state == 2 ? 'num_on' : 'num'">2</div>
				<div class="ml5 fs20 lh34" :class="state == 2 ? 'blue' : 'cold7d'">资质上传</div>
				<div class="mlr25" :class="state == 2 ? 'line_on' : 'line'"></div>
				<div :class="state == 3 ? 'num_on' : 'num'">3</div>
				<div class="ml5 fs20 lh34" :class="state == 3 ? 'blue' : 'cold7d'">审核认证</div>
				<div class="mlr25" :class="state == 3 ? 'line_on' : 'line'"></div>
				<div :class="state == 4 ? 'num_on' : 'num'">4</div>
				<div class="ml5 fs20 lh34" :class="state == 4 ? 'blue' : 'cold7d'">注册成功</div>
			</div>
			<div class="part1">
				<div v-if="state == 1">
					<div class="flex-box flex-between mb30 pr">
						<div class="fs16 col3 lh28 mr10">省份：</div>
						<div class="select_box relative">
							<div class="flex-box select flex-center fs16 cursor"
								@click="showProvince = !showProvince, showCity = showArea = false">
								<div class="pr10" :class="provinceIndex == -1 ? 'col90' : 'col04'">
									{{ provinceIndex == -1 ?
										'请选择' : provinceList[provinceIndex].name }}
								</div>
							</div>
							<div class="data_list" :class="showProvince ? 'show' : ''">
								<div class="item fs16 cursor" v-for="(item, index) in provinceList" :key="index"
									@click="chooseProvince(index)">{{ item.name }}</div>
							</div>
						</div>
						<div class="fs16 col3 lh28 mr10">城市：</div>
						<div class="select_box relative">
							<div class="flex-box select flex-center fs16 cursor"
								@click="showCity = !showCity, showProvince = showArea = false">
								<div class="pr10" :class="cityIndex == -1 ? 'col90' : 'col04'">
									{{ cityIndex == -1 ? '请选择' :
										cityList[cityIndex].name }}
								</div>
							</div>
							<div class="data_list" :class="showCity ? 'show' : ''">
								<div class="item fs16 cursor" v-for="(item, index) in cityList" :key="index"
									@click="chooseCity(index)">{{ item.name }}</div>
							</div>
						</div>
						<div class="fs16 col3 lh28 mr10">区：</div>
						<div class="select_box relative">
							<div class="flex-box select flex-center fs16 cursor"
								@click="showArea = !showArea, showCity = showProvince = false">
								<div class="pr10" :class="areaIndex == -1 ? 'col90' : 'col04'">
									{{ areaIndex == -1 ? '请选择' :
										areaList[areaIndex].name }}
								</div>
							</div>
							<div class="data_list" :class="showArea ? 'show' : ''">
								<div class="item fs16 cursor" v-for="(item, index) in areaList" :key="index"
									@click="chooseArea(index)">{{ item.name }}</div>
							</div>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb17">详细地址：</div>
					<div class="pr">
						<div class="">
							<textarea class="textarea" name="" id="" placeholder="请输入详细地址，例：XX省XX市XX县X"
								v-model="institution.address"></textarea>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb17">收货地址：</div>
					<div class="pr">
						<div class="">
							<textarea class="textarea" name="" id="" placeholder="请输入详细地址，例：XX省XX市XX县X"
								v-model="institution.myaddress"></textarea>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb17">医院全称：</div>
					<div class="pr">
						<div class="">
							<div class="part2">
								<input class="input" type="text" name="account" placeholder="请输入医院名称"
									v-model="institution.company_name" />
							</div>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb17">联系人：</div>
					<div class="pr">
						<div class="">
							<div class="part2">
								<input class="input" type="text" placeholder="请输入联系人姓名" v-model="institution.contact" />
							</div>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb17">联系人手机号：</div>
					<div class="pr">
						<div :class="isPhone ? 'prompt_border1' : ''">
							<div class="part2">
								<input class="input" type="number" maxlength="11" placeholder="请输入手机号码"
									v-model="institution.mobile" />
							</div>
						</div>
						<div class="fs18 red lh28 prompt_info" v-if="isPhone">手机号码格式有误</div>
					</div>
					<div class="fs16 col3 lh28 mb17">验证码：</div>
					<div class="pr">
						<div class="flex-box">
							<div :class="isCode ? 'prompt_border1' : ''" class="flex-grow-1">
								<div class="part2 part33 flex-grow-1">
									<input class="input" id="" type="text" name="" placeholder="请输入验证码"
										v-model="institution.code" />
								</div>
							</div>
							<button :class="captcha == '获取验证码' ? 'code_btn_on' : 'code_btn'" class="ml15 tc mb30 point"
								@click="handleCaptcha">
								{{ captcha }}
							</button>
						</div>
						<div class="fs18 red lh28 prompt_info" v-if="isCode">验证码错误</div>
					</div>
					<div class="fs16 col3 lh28 mb17">登录密码：</div>
					<div class="pr">
						<div :class="isPassword ? 'prompt_border1' : ''">
							<div class="part2 flex-box">
								<input class="input" :type="showPwd ? 'text' : 'password'"
									placeholder="请输入登录密码（6-20位数字与字母组合）" v-model="institution.password" />
								<img @click="showPwd = !showPwd" v-if="showPwd" class="img2 point"
									src="../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
								<img @click="showPwd = !showPwd" v-else class="img2 point"
									src="../../assets/static/icon/jxr_login_hide.png" alt="" id="eye" />
							</div>
						</div>
						<div class="fs18 red lh28 prompt_info" v-if="isPassword">密码错误</div>
					</div>
					<div class="fs16 col3 lh28 mb17">再次输入密码：</div>
					<div class="pr">
						<div :class="isRepeatPassword ? 'prompt_border1' : ''">
							<div class="part2 flex-box">
								<input class="input" :type="showPwd ? 'text' : 'password'" placeholder="请再次输入密码"
									v-model="institution.repeat_password" />
								<img @click="showPwd = !showPwd" v-if="showPwd" class="img2 point"
									src="../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
								<img @click="showPwd = !showPwd" v-else class="img2 point"
									src="../../assets/static/icon/jxr_login_hide.png" alt="" id="eye" />
							</div>
							<div class="fs18 red lh28 prompt_info" v-if="isRepeatPassword">两次密码输入不一致</div>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb17">业务员邀请码(选填)：</div>
					<div class="pr">
						<div :class="isInvite ? 'prompt_border1' : ''">
							<div class="part2">
								<input class="input" type="text" name="account" placeholder="请输入业务员邀请码"
									v-model="institution.invite_code" />
							</div>
						</div>
						<div class="fs18 red lh28 prompt_info" v-if="isInvite">未检测到此邀请码</div>
					</div>
				</div>
				<div v-if="state == 2">
					<div class="fs16 col3 lh56 mb30">请选择您的机构类型：</div>
					<div class="flex-box flex-wrap flex-end pl5">
						<div v-for="(item, index) in businessList" :key="index" @click="chooseBusiness(index, item.id)"
							class="mb30 flex-box flex-end minw280 point">
							<img v-if="businessIndex == index" class="login_checked mr10"
								src="../../assets/static/icon/jxr_login_checked.png" alt="" />
							<img v-else class="login_checked mr10" src="../../assets/static/icon/jxr_login_check.png"
								alt="" />
							<div class="fs16 col3 lh28 flex-grow-1">
								{{ item.name }}
							</div>
						</div>
					</div>
					<div class="fs16 col3 lh28 mb20">医院营业执照号：</div>
					<div class="part2">
						<input class="input" type="text" name="" placeholder="OCR识别自动填写" disabled
							v-model="institution.license_no" />
					</div>
					<div class="flex mb20">
						<div class="fs16 col3 lh28 flex-grow-1">有效期（起）：</div>
						<div class="fs16 col3 lh28 flex-grow-1">有效期（止）：</div>
					</div>
					<div class="flex mb20">
						<div class="part2 flex-grow-1 mr8">
							<input class="input" type="text" name="" placeholder="OCR识别自动填写" disabled
								v-model="institution.expire_start" />
						</div>
						<div class="part2 flex-grow-1 ml8">
							<input class="input" type="text" name="" placeholder="OCR识别自动填写" disabled
								v-model="institution.expire_end" />
						</div>
					</div>
					<div class="flex mb30">
						<div class="flex-grow-1 fs16 col3 lh28">营业执照（公章）：</div>
						<upLoad @upSuc="upLoadSuc" dataName="license_image" v-if="institution.license_image == ''">
							<div class="upload_part point">
								<img class="icon" src="../../assets/static/icon/jxr_login_upload.png" alt="" />
								<div class="tc fs16 cold3 lh28">请上传营业执照照片</div>
							</div>
						</upLoad>
						<div v-else class="upload_part4 pr">
							<img class="close_icon point" src="../../assets/static/icon/jxr_login_close2.png"
								@click="institution.license_image = ''" alt="" />
							<img class="imgs1" :src="institution.license_image" alt="" />
						</div>
					</div>
					<div class="fs16 col3 lh28 mb20">医疗经营执照号：</div>
					<div class="part2">
						<input class="input" type="text" name="" placeholder="OCR识别自动填写"
							v-model="institution.medical_license_no" />
					</div>
					<div class="flex mb20">
						<div class="fs16 col3 lh28 flex-grow-1">有效期（起）：</div>
						<div class="fs16 col3 lh28 flex-grow-1">有效期（止）：</div>
					</div>
					<div class="flex mb20">
						<div class="date_picker flex-grow-1 fs16 mr8">
							<input class="input_time" v-model="institution.medical_expire_start" type="date"
								@click="openDatePicker" />
							<div class="pl10" :class="institution.medical_expire_start == '' ? 'cold3' : ''">
								{{
									institution.medical_expire_start == '' ? '请选择' : institution.medical_expire_start }}
							</div>
						</div>
						<div class="date_picker flex-grow-1 fs16 ml8">
							<input class="input_time" v-model="institution.medical_expire_end" type="date"
								@click="openDatePicker" />
							<div class="pl10" :class="institution.medical_expire_end == '' ? 'cold3' : ''">
								{{
									institution.medical_expire_end == '' ? '请选择' : institution.medical_expire_end }}
							</div>
						</div>
					</div>
					<div class="flex mb30">
						<div class="flex-grow-1 fs16 col3 lh28">执业许可证（公章）：</div>
						<upLoad @upSuc="upLoadSuc" dataName="medical_license_image"
							v-if="institution.medical_license_image == ''">
							<div class="upload_part point">
								<img class="icon" src="../../assets/static/icon/jxr_login_upload.png" alt="" />
								<div class="tc fs16 cold3 lh28">请上传执业许可证照片</div>
							</div>
						</upLoad>
						<div v-else class="upload_part4 pr">
							<img class="close_icon point" src="../../assets/static/icon/jxr_login_close2.png"
								@click="institution.medical_license_image = ''" alt="" />
							<img class="imgs1" :src="institution.medical_license_image" alt="" />
						</div>
					</div>
					<div class="fs16 col3 lh28 mb20">医院法人：</div>
					<div class="part2">
						<input class="input" type="text" name="" placeholder="请输入法人姓名" v-model="institution.legal_person" />
					</div>
					<div class="fs16 col3 lh28 mb20">法人身份证号：</div>
					<div class="part2">
						<input class="input" type="text" name="" placeholder="上传营业执照自动识别" disabled
							v-model="institution.legal_no" />
					</div>
					<div class="fs16 col3 lh28 mb20">法人身份证：</div>
					<div class="flex flex-between mb40">
						<upLoad @upSuc="upLoadSuc" dataName="idcard_face" v-if="institution.idcard_face == ''">
							<div class="upload_part point">
								<img class="icon" src="../../assets/static/icon/jxr_login_upload.png" alt="" />
								<div class="tc fs16 cold3 lh28">身份证正面照</div>
							</div>
						</upLoad>
						<div v-else class="upload_part4 pr">
							<img class="close_icon point" src="../../assets/static/icon/jxr_login_close2.png" alt=""
								@click="institution.idcard_face = ''" />
							<img class="imgs1" :src="institution.idcard_face" alt="" />
						</div>
						<upLoad @upSuc="upLoadSuc" dataName="idcard_back" v-if="institution.idcard_back == ''">
							<div class="upload_part point">
								<img class="icon" src="../../assets/static/icon/jxr_login_upload.png" alt="" />
								<div class="tc fs16 cold3 lh28">身份证背面照</div>
							</div>
						</upLoad>
						<div v-else class="upload_part4 pr">
							<img class="close_icon point" src="../../assets/static/icon/jxr_login_close2.png" alt=""
								@click="institution.idcard_back = ''" />
							<img class="imgs1" :src="institution.idcard_back" alt="" />
						</div>
					</div>
					<template v-for="(item, index) in others" :key="index">
						<div class="fs16 col3 lh28 mb20">其他材料（选填）：</div>
						<div class="flex-box">
							<div class="part2 flex-grow-1">
								<input class="input" type="text" name="" placeholder="请输入其他材料信息" v-model="item.title" />
							</div>
							<img class="login_add ml20 mb30 point" src="../../assets/static/icon/jxr_login_add.png"
								@click="onOtherAdd()" alt="" />
						</div>
						<div class="fs16 col3 lh28 mb20">其他材料（图片）：</div>
						<div class="flex flex-between flex-wrap pb15">
							<upLoad @upSuc="upLoadSuc" dataName="others" :dataIndex="index" v-if="item.image == ''">
								<div class="upload_part upload_part2 point mb25 flex-box flex-center"
									style="padding-top:0;">
									<img class="icon" src="../../assets/static/icon/jxr_login_upload.png" alt="" />
								</div>
							</upLoad>
							<div v-else class="upload_part4 pr mb25">
								<img class="close_icon point" src="../../assets/static/icon/jxr_login_close2.png" alt=""
									@click="onOtherReduce(index)" />
								<img class="imgs1" :src="item.image" alt="" />
							</div>
						</div>
					</template>
				</div>
				<div class="flex-box lh52">
					<img @click="clickAgree" v-if="agree" class="login_checked point mr15"
						src="../../assets/static/icon/jxr_login_checked.png" alt="" />
					<img @click="clickAgree" v-else class="login_checked point mr15"
						src="../../assets/static/icon/jxr_login_check.png" alt="" />
					<div class="fs16 col3">
						我已阅读并同意
						<span class="blue point" @click="showAgree(1)">《用户协议》</span>
						<span class="blue point" @click="showAgree(2)">《隐私政策》</span>
					</div>
				</div>
				<button v-if="state == 1" :class="canNext ? 'btn_login_on' : 'btn_login'" class="point"
					@click="canNext ? next() : ''">下一步</button>
				<button v-if="state == 2" :class="canRegister ? 'btn_login_on' : 'btn_login'" class="point"
					@click="canRegister ? register() : ''">注册</button>
				<div class="tc lh52 mt65 fs16 col3">遇到问题？请<span class="point blue">联系客服</span></div>
			</div>
		</div>
		<!--《用户协议》弹窗  -->
		<popup :visible="sucPop" @close="sucPop = false">
			<div class="popup w1440">
				<div class="tc fs24 col3 tc lh34 mb45">《用户协议》</div>
				<div class="line2"></div>
				<div class="popup_main" v-html="agreement1"></div>
				<div @click="sucPop = false" class="fs16 col3 tc close_btn cursor">关闭</div>
			</div>
		</popup>
		<!-- 《隐私政策》弹窗 -->
		<popup :visible="sucPop2" @close="sucPop2 = false">
			<div class="popup w1440">
				<div class="tc fs24 col3 tc lh34 mb45">《隐私政策》</div>
				<div class="line2"></div>
				<div class="popup_main" v-html="agreement2"></div>
				<div @click="sucPop2 = false" class="fs16 col3 tc close_btn cursor">关闭</div>
			</div>
		</popup>
		<!-- 等待审核弹窗 -->
		<popup :visible="sucPop3" @close="closeRegister">
			<div class="popup3">
				<img @click="closeRegister" class="pop_close point" src="../../assets/static/icon/jxr_login_close.png"
					alt="" />
				<div class="tc fs36 blue fwb lh50 mb25">信息已提交，请耐心等待审核</div>
				<div class="colc2 fs24 lh34 tc">（审核通过将在2-3个工作日内短信通知）</div>
			</div>
		</popup>
	</div>
</template>
<script>
import { useHead } from "@unhead/vue";
import upLoad from "../../components/UploadFormat.vue";
import * as com from '@/utils/common.js'; // 导入公共方法
export default {
	components: { upLoad },
	setup() {
		useHead({
			title: "注册-小狮优选",
			meta: [
				{ name: "description", content: "This is my page description" },
				{ property: "og:title", content: "My Page Title" },
				{ property: "og:description", content: "This is my page description" },
				{ property: "og:url", content: "https://example.com/my-page" },
				{ property: "og:image", content: "https://example.com/my-image.jpg" },
			],
			link: [{ rel: "canonical", href: "https://example.com/my-page" }],
		});
	},
	mounted() {
		this.$store.commit("setHeader", false);
		this.$store.commit("setRouter", false);
		this.fetchArea();
		this.getBusiness();
		this.$cookies.remove('token');
		this.$cookies.remove('userinfo');
	},
	beforeUnmount() {
		this.$store.commit("setHeader", true);
		this.$store.commit("setRouter", true);
	},
	data() {
		return {
			state: 1, //1:资料填写 2:资质上传 3:审核认证 4:注册成功
			showPwd: false,
			agree: true,
			sucPop: false,
			sucPop2: false,
			sucPop3: false,
			businessList: [],
			businessIndex: -1,

			captcha: "获取验证码",
			totalTime: 60,
			canClick: true, // 节流
			clockTimer: null, // 定时器

			showProvince: false,
			showCity: false,
			showArea: false,
			provinceList: [],
			cityList: [],
			areaList: [],
			provinceIndex: -1,
			cityIndex: -1,
			areaIndex: -1,

			institution: {
				province_id: 0,
				city_id: 0,
				district_id: 0,
				address: '',
				myaddress: '',
				company_name: '',
				contact: '',
				mobile: '',
				code: '',
				password: '',
				repeat_password: '',
				invite_code: '',

				business_ids: [],
				license_image: '',
				license_no: '',
				tax_no: '',
				expire_start: '',
				expire_end: '',
				medical_license_image: '',
				medical_license_no: '',
				medical_expire_start: '',
				medical_expire_end: '',
				legal_person: '',
				legal_no: '',
				idcard_face: '',
				idcard_back: '',
				idcard_start: '',
				idcard_end: ''
			},
			others: [{
				title: '',
				image: ''
			}],
			isPhone: false,
			isCode: false,
			isPassword: false,
			isRepeatPassword: false,
			isInvite: false,
			agreement1: '',//用户协议 隐私政策
			agreement2: '',//用户协议 隐私政策
		};
	},
	computed: {
		canNext() {
			// 下一步
			return (
				this.state === 1 &&
				this.institution.province_id !== 0 &&
				this.institution.city_id !== 0 &&
				this.institution.district_id !== 0 &&
				this.institution.address !== '' &&
				this.institution.myaddress !== '' &&
				this.institution.company_name !== '' &&
				this.institution.contact !== '' &&
				this.institution.mobile !== '' &&
				this.institution.code !== '' &&
				this.institution.password !== '' &&
				this.institution.repeat_password !== '' &&
				this.agree
			);
		},
		canRegister() {
			// 注册
			return (
				this.state === 2 &&
				this.institution.business_ids.length > 0 &&
				this.institution.license_image !== '' &&
				this.institution.license_no !== '' &&
				this.institution.tax_no !== '' &&
				this.institution.expire_start !== '' &&
				this.institution.expire_end !== '' &&
				this.institution.medical_license_image !== '' &&
				this.institution.medical_license_no !== '' &&
				this.institution.medical_expire_start !== '' &&
				this.institution.medical_expire_end !== '' &&
				this.institution.legal_person !== '' &&
				this.institution.legal_no !== '' &&
				this.institution.idcard_face !== '' &&
				this.institution.idcard_back !== '' &&
				this.institution.idcard_start !== '' &&
				this.institution.idcard_end !== '' &&
				this.agree
			);
		},
	},
	methods: {
		// 获取地区
		async fetchArea() {
			try {
				this.provinceList = await com.getArea();
			} catch (error) {
				console.error("获取区域信息失败:", error);
			}
		},
		// 获取机构类型
		getBusiness() {
			let that = this;
			that.$api.getBusiness().then(res => {
				that.businessList = res.data;
			})
		},
		// 选择省份
		chooseProvince(index) {
			this.provinceIndex = index;
			this.cityList = this.provinceList[index].childlist;
			this.institution.province_id = this.provinceList[index].id;
			this.showProvince =
				this.showCity =
				this.showArea = false;
		},
		// 选择城市
		chooseCity(index) {
			this.cityIndex = index;
			this.areaList = this.cityList[index].childlist;
			this.institution.city_id = this.cityList[index].id;
			this.showProvince =
				this.showCity =
				this.showArea = false;
		},
		// 选择区域
		chooseArea(index) {
			this.areaIndex = index;
			this.institution.district_id = this.areaList[index].id;
			this.showProvince =
				this.showCity =
				this.showArea = false;
		},
		// 点击同意协议
		clickAgree() {
			this.agree = !this.agree;
		},
		//显示协议和隐私政策
		showAgree(index) {
			let that = this;
			if (index == 1) {
				that.sucPop = true;
			} else {
				that.sucPop2 = true;
			}
			that.$api.getAgreement({ id: index }).then(res => {
				if (index == 1) {
					that.agreement1 = res.data.content;
				} else {
					that.agreement2 = res.data.content;
				}

			})
		},
		// 获取验证码
		handleCaptcha() {
			let that = this;
			if (!that.canClick) return; // 节流 防止频繁访问接口
			if (com.checkPhone(that.institution.mobile)) {
				that.isPhone = false;
				that.canClick = false;
				that.captcha = that.totalTime + "s后重新发送";
				that.clockTimer = window.setInterval(() => {
					that.totalTime--;
					that.captcha = that.totalTime + "s后重新发送";
					if (that.totalTime < 0) {
						window.clearInterval(that.clockTimer);
						that.captcha = "重新发送验证码";
						that.totalTime = 60;
						that.canClick = true;
					}
				}, 1000);
				that.$api.getCode({
					mobile: that.institution.mobile,
					event: 'register'
				});
			} else {
				that.isPhone = true;
			}
		},
		// 下一步
		next() {
			// 校验手机号
			if (!com.checkPhone(this.institution.mobile)) {
				this.isPhone = true;
			} else {
				this.isPhone = false;
			}
			// 校验验证码
			if (!com.checkCode(this.institution.code)) {
				this.isCode = true;
			} else {
				this.isCode = false;
			}
			// 校验密码
			if (!com.checkPassword(this.institution.password)) {
				this.isPassword = true;
			} else {
				this.isPassword = false;
			}
			// 再次输入
			if (this.institution.password !== this.institution.repeat_password || this.institution.repeat_password == '') {
				this.isRepeatPassword = true;
			} else {
				this.isRepeatPassword = false;
			}
			// 若有错误则无法下一步
			if (this.isPhone || this.isCode || this.isPassword || this.isRepeatPassword) {
				return;
			}
			this.state = 2;
			console.log(this.institution)
		},
		// 选择机构
		chooseBusiness(index, id) {
			this.businessIndex = index;
			this.institution.business_ids = [id];
		},
		// 选择起始时间
		openDatePicker(event) {
			// 触发日期选择器
			event.target.showPicker(); // 仅在支持的浏览器中有效
		},
		// 上传图片成功
		upLoadSuc(e) {
			console.log(e)
			if (e.name == 'others') {
				this.others[e.index].image = e.url;
			} else {
				this.institution[e.name] = e.url;
				this.identify(e.name, e.url);
			}
		},
		// 识别
		identify(type, img) {
			let that = this;
			if (type == 'idcard_face' || type == 'idcard_back') {
				that.$api.identifyId({
					type: type,
					img: img
				}).then(ret => {
					if (ret.code == 1) {
						if (type == 'idcard_face') {
							that.institution.legal_no = ret.data.legal_no;
							that.institution.legal_person = ret.data.legal_person;
						} else if (type == 'idcard_back') {
							that.institution.idcard_end = ret.data.idcard_end;
							that.institution.idcard_start = ret.data.idcard_start;
						}
					} else {
						that.$message({
							customClass: 'custom-message',
							message: "识别失败，请重新上传",
							type: "error",
							duration: 3000,
						});
					}
				})
			} else if (type == 'license_image') {
				that.$api.identifyLicense({
					type: type,
					img: img
				}).then(ret => {
					if (ret.code == 1) {
						that.institution.license_no = ret.data.tax_no;
						that.institution.tax_no = ret.data.tax_no;
						that.institution.expire_start = ret.data.expire_start;
						that.institution.expire_end = ret.data.expire_end;
					} else {
						that.$message({
							customClass: 'custom-message',
							message: "识别失败，请重新上传",
							type: "error",
							duration: 3000,
						});
					}
				})
			}
		},
		// 删除其他材料
		onOtherReduce(index) {
			this.others.splice(index, 1);
		},
		// 添加其他材料
		onOtherAdd() {
			this.others.push({
				title: '',
				image: ''
			})
		},
		// 注册
		register() {
			if (this.businessIndex == -1) {
				this.$message({
					customClass: 'custom-message',
					message: '请选择机构类型',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (new Date(this.institution.medical_expire_start).getTime() / 1000 > new Date(this.institution.medical_expire_end).getTime() / 1000) {
				this.$message({
					customClass: 'custom-message',
					message: '医疗经营执照有效期错误',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (this.institution.license_image == '') {
				this.$message({
					customClass: 'custom-message',
					message: '请上传营业执照',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (this.institution.medical_license_image == '') {
				this.$message({
					customClass: 'custom-message',
					message: '请上传执业许可证照',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (this.institution.idcard_face == '') {
				this.$message({
					customClass: 'custom-message',
					message: '请上传身份证正面',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (this.institution.idcard_back == '') {
				this.$message({
					customClass: 'custom-message',
					message: '请上传身份证背面',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (this.institution.legal_person == '') {
				this.$message({
					customClass: 'custom-message',
					message: '请填写医院法人',
					type: "error",
					duration: 3000,
				})
				return;
			}
			if (this.institution.legal_no == '' || this.institution.idcard_start == '' || this.institution.idcard_end == '') {
				this.$message({
					customClass: 'custom-message',
					message: '身份证上传有误',
					type: "error",
					duration: 3000,
				})
				return;
			}
			this.institution.others = this.others;
			this.$api.register({ ...this.institution }).then(res => {
				if (res.code == 1) {
					this.sucPop3 = true;
				} else {
					this.$message({
						customClass: 'custom-message',
						message: res.msg,
						type: "error",
						duration: 3000,
					})
				}
			})
		},
		//关闭注册弹窗
		closeRegister() {
			this.sucPop3 = false;
			this.$router.push('/');
		}
	},
};
</script>
<style lang="less" scoped>
.cold7d {
	color: #d7d4d4;
}

.col36 {
	color: #363636;
}

.point {
	cursor: pointer;
}

.bg_f9 {
	background: #f9f9f9;
}

.head_part {
	// width: 1400px;
	margin: 0 auto;
	padding: 66px 0;
}

.login_logo {
	width: 220px;
	display: block;
	object-fit: contain;
}

.line {
	width: 1px;
	height: 45px;
	background: #979797;
}

.col-36 {
	color: #363636;
}

.fw-600 {
	font-weight: 600;
}

.main {
	// width: 1400px;
	margin: 0 auto 60px;
	background: #ffffff;
	padding: 84px 0 66px;
}

.progess_part {
	padding-bottom: 82px;
	border-bottom: 1px solid #e6e6e6;
}

.progess_part .num_on,
.progess_part .num {
	width: 34px;
	height: 34px;
	background: #ffd040;
	text-align: center;
	line-height: 34px;
	border-radius: 50%;
	overflow: hidden;
	font-size: 20px;
	color: #ffffff;
	margin-right: 5px;
}

.progess_part .num {
	background: #e6e6e6;
}

.progess_part .line_on,
.progess_part .line {
	width: 90px;
	height: 0px;
	border-top: 1px dashed #3d7efe;
}

.progess_part .line {
	border-color: #d7d4d4;
}

.part1 {
	width: 660px;
	margin: 0 auto;
	padding-top: 80px;
}

.part1 .title {
	font-weight: 600;
	font-size: 30px;
	color: #3d7efe;
	line-height: 42px;
}

.part2 {
	width: 660px;
	height: 60px;
	margin: 0 auto 30px;
	border-radius: 8px;
	overflow: hidden;
	border-radius: 8px;
	border: 1px solid #cccccc;
	padding-left: 16px;
}

.part2 .img1 {
	width: 28px;
	height: 28px;
	display: block;
	object-fit: contain;
	margin-right: 12px;
}

.part2 .img2 {
	width: 24px;
	height: 24px;
	display: block;
	object-fit: contain;
	margin-right: 16px;
}

.part2 input {
	width: 100%;
}

.part3 {
	margin: 0 auto 16px;
}

.check_img {
	width: 14px;
	height: 14px;
	margin-right: 6px;
	background: rgba(240, 84, 77, 1);
	margin-top: 0;
}

input[type="checkbox"] {
	width: 14px;
	height: 14px;
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	line-height: 15px;
	position: relative;
}

input[type="checkbox"]::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	background: #fff;
	width: 100%;
	height: 100%;
	border: 1px solid #c5cdd6;
}

input[type="checkbox"]:checked::before {
	content: "\2713";
	background-color: #3d7efe;
	position: absolute;
	bottom: 4px;
	left: 0px;
	width: 100%;
	border: 1px solid #3d7efe;
	color: #fff;
	font-size: 10px;
	font-weight: bold;
}

.input {
	padding: 0;
	font-size: 16px;
	height: 100%;
	line-height: 100%;
	flex: 1;
	border: none;
	outline: none;
}

.textarea {
	resize: none;
	padding: 17px 16px;
	font-size: 16px;
	width: 100%;
	height: 120px;
	border-radius: 8px;
	border: 1px solid #cccccc;
	outline: none;
	margin: 0 auto 34px;
}

.input::placeholder,
.textarea::placeholder {
	font-size: 16px;
	color: #d3d3d3;
}

.part4 {
	width: 386px;
	margin: 0 auto 44px;
}

.btn_login_on,
.btn_login {
	border: none;
	margin: 92px auto 0;
	font-size: 18px;
	color: #fff;
	font-weight: 500;
	text-align: center;
	width: 660px;
	height: 60rpx;
	line-height: 60px;
	border-radius: 8px;
	background: #3d7efe;
}

.btn_login {
	background: #bdd3ff;
}

.blue {
	color: #3d7efe;
}

.login_right {
	width: 20px;
	height: 20px;
	display: block;
	object-fit: contain;
}

.code_btn_on,
.code_btn {
	width: 176px;
	height: 60px;
	line-height: 60px;
	background: #3d7efe;
	border-radius: 8px;
	font-weight: 500;
	font-size: 18px;
	color: #ffffff;
}

.code_btn {
	background: #c2c2c2;
}

.prompt_info {
	position: absolute;
	z-index: 2;
	left: 0;
	top: 70px;
}

.red {
	color: #ed1515;
}

.prompt_border1 {
	width: 660px;
	height: 66px;
	// border: 2px solid #ffd4d4;
	border-radius: 11px;
	margin: 0 auto 30px;
}

.prompt_border1 .part2 {
	// width: 100%;
	// height: 100%;
	border-color: #ed1515;
}

.prompt_border1 .part33 {
	width: 100%;
}

.login_checked {
	width: 22px;
	height: 22px;
	display: block;
	object-fit: contain;
}

.mt65 {
	margin-top: 65px;
}

.popup {
	// width: 1400px;
	padding: 106px 120px 80px;
	background: #ffffff;
	box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.23);
	border-radius: 20px;
}

.line2 {
	width: 1160px;
	height: 1px;
	background: repeating-linear-gradient(to right,
			rgba(51, 51, 51, 0),
			rgba(51, 51, 51, 1),
			rgba(51, 51, 51, 0));
	margin: 0 auto 45px;
}

.popup_main {
	height: 50vh;
	overflow-y: scroll;
	margin: 0 auto 77px;
}

.close_btn {
	width: 398px;
	text-align: center;
	line-height: 64px;
	height: 66px;
	border-radius: 41px;
	border: 1px solid #b0b0b0;
	margin: 0 auto;
}

.minw280 {
	max-width: 376px;
	min-width: 296px;
}

.pl50 {
	padding-left: 50rpx;
}

.ml50 {
	margin-left: 50px;
}

.mr8 {
	margin-right: 8px;
}

.ml8 {
	margin-left: 8px;
}

.upload_part {
	width: 322px;
	height: 160px;
	border-radius: 8px;
	border: 1px solid #cccccc;
	position: relative;
}

.upload_part .icon {
	width: 70px;
	height: 64px;
	display: block;
	object-fit: contain;
	margin: 32px auto 16px;
}

.upload_part2 {
	padding-top: 47px;
}

.upload_part3 {
	padding-top: 65px;
}

.upload_part3 .add_upload {
	widows: 30px;
	height: 30px;
	display: block;
	object-fit: contain;
	margin: 0 auto;
}

.cold3 {
	color: #d3d3d3;
}

.upload_part4 {
	width: 322px;
	height: 160px;
	border-radius: 8px;
	overflow: hidden;
}

.upload_part4 .close_icon {
	width: 20px;
	height: 20px;
	display: block;
	object-fit: contain;
	position: absolute;
	z-index: 2;
	top: 8px;
	right: 8px;
}

.upload_part4 .imgs1 {
	width: 322px;
	height: 160px;
	display: block;
	object-fit: cover;
	border-radius: 8px;
	overflow: hidden;
}

.login_add {
	widows: 30px;
	height: 30px;
	display: block;
	object-fit: contain;
}

.popup3 {
	width: 778px;
	padding: 20px 22px 82px;
	background: #ffffff;
	box-shadow: 0px 8px 31px 0px rgba(0, 0, 0, 0.27);
	border-radius: 20px;
}

.popup3 .pop_close {
	width: 40px;
	height: 40px;
	display: block;
	margin: 0 0 28px auto;
}

.lh50 {
	line-height: 50px;
}

.colc2 {
	color: #c2c2c2;
}

.pr {
	position: relative;
}

.picker_part {
	width: 134px;
	height: 60px;
	line-height: 58px;
	border-radius: 8px;
	border: 1px solid #cccccc;
}

.province_part {
	width: 134px;
	height: 200px;
	overflow-y: scroll;
	position: absolute;
	top: 65px;
	left: 0;
	border-radius: 8px;
	border: 1px solid #cccccc;
	background: #fff;
	z-index: 9;
	left: 85px;
}

.city_part {
	left: 315px;
}

.district_part {
	right: 0px;
	left: unset;
}

.province_part .item {
	line-height: 50px;
	padding: 0 10px;
}

.item:hover {
	background: #3d7efe;
	color: #fff;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.picker_part .arrow {
	width: 20px;
	height: 20px;
	display: block;
	object-fit: contain;
}

.select_box {
	width: 134px;
	height: 60px;
	border-radius: 8px;
	border: 1px solid rgba(98, 134, 171, 0.2);
}

.select_box .select {
	height: 58px;
}

.select_box .select::after {
	content: "";
	display: block;
	background: url('/src/assets/static/icon/c_arrowd.png') no-repeat center;
	background-size: 100%;
	width: 16px;
	height: 16px;
}

.data_list {
	max-height: 300px;
	overflow-y: scroll;
	position: absolute;
	top: 50px;
	left: 0;
	right: 0;
	background-color: #fff;
	border-radius: 0 0 8px 8px;
	display: none;
	border: 1.6px solid rgba(98, 134, 171, 0.2);
	z-index: 2;
}

.data_list.show {
	display: block;
}

.data_list .item {
	height: 50px;
	line-height: 50px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	padding: 0 24px;
}

.data_list .item:hover {
	background: #1275FF;
	color: #fff;
}

.part33 {
	width: 100%
}

.date_picker {
	height: 60px;
	margin-bottom: 30px;
	border-radius: 8px;
	overflow: hidden;
	border-radius: 8px;
	border: 1px solid #cccccc;
	position: relative;

	.input_time {
		padding-left: 16px;
		width: 100%;
		height: 58px;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		cursor: pointer;
	}

	div {
		height: 58px;
		line-height: 58px;
	}

}
</style>
